import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/nomina/frecuencia_pago';
import Frecuencia from './FrecuenciaPago';

const ms2p = (state) => {
  return {
    ...state.frecuencia_pago_nomina,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Frecuencia);
